/** Раздел справки: заголовок верхнего уровня и относящийся к нему markdown-текст */
export type HelpSection = {
  /**
   * Место раздела в справке — по нему, а не по переводимому заголовку, раздел и опознаётся:
   * иначе смена языка сворачивала бы справку целиком. Порядок разделов во всех языках один.
   */
  id: string;
  title: string;
  body: string;
};

/** Заголовок раздела верхнего уровня в тексте справки */
const SECTION_HEADING = /^###\s+(.+)$/;

/**
 * Разбивает markdown справки на разделы верхнего уровня — каждый из них сворачивается отдельно.
 * Текст до первого заголовка в справке не предусмотрен и в разделы не попадает.
 */
export const splitHelpSections = (markdown: string): HelpSection[] => {
  const sections: HelpSection[] = [];

  for (const line of markdown.split('\n')) {
    const heading = line.match(SECTION_HEADING);

    if (heading) {
      sections.push({ id: String(sections.length), title: heading[1].trim(), body: '' });
      continue;
    }

    const currentSection = sections.at(-1);
    if (currentSection) currentSection.body += `${line}\n`;
  }

  return sections.map((section) => ({ ...section, body: section.body.trim() }));
};
